import { render, staticRenderFns } from "./MaybankForm2.vue?vue&type=template&id=32c8cf91"
import script from "./MaybankForm2.vue?vue&type=script&lang=js"
export * from "./MaybankForm2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports